import { fromJS } from 'immutable';

import { LOADED_APPROVALS_SUCCESS } from '../../actions/approval/main';

const defaultState = fromJS({
  id: 0,
  buyerId: 0,
  name: '',
  buyer: '',
  harvcoLead: '',
  clientLead: '',
});

export default function(state = defaultState, action) {
  switch (action.type) {
    case LOADED_APPROVALS_SUCCESS:
      return mapProject(state, action);

    default:
      return state;
  }
}

/**
 * Map project data from api response.
 *
 * @param state {Immutable.Map} State.
 * @param action {Object} Action object.
 */
function mapProject(state, action) {
  const response = action.response;

  if (response.status === 'success') {
    return state.merge({
      id: response.data.id,
      buyerId: response.data.buyerId,
      category: response.data.category,
      buyer: response.data.buyer ? response.data.buyer.legalName : '',
      harvcoLead: response.data.harvcoLead ? response.data.harvcoLead.userName : '',
      clientLead: response.data.clientLead ? response.data.clientLead.fullName : '',
    });
  }

  return state;
}
